import _styled, { default as _styled2 } from "styled-components";
import { nonNullable } from "~/features/app/utils";
import { up } from "~/features/app/screens";
import { FilterBar, type Filter } from "~/features/filter/filter-bar";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { useMediaQuery } from "~/features/ui/use-media-query";
import { Wrap } from "~/features/ui/wrap";
const DEFAULT_CATEGORY = {
  label: "All",
  value: ""
};
const DEFAULT_INDUSTRY = {
  label: "All Industries",
  value: ""
};
export type BlogFilterOption = {
  title?: string | null;
  slug?: string | null;
};
function mapOptions(options: BlogFilterOption[]) {
  return options.map(option => option.title && option.slug ? {
    label: option.title,
    value: option.slug
  } : null).filter(nonNullable);
}
type Props = {
  categories?: BlogFilterOption[];
  industries?: BlogFilterOption[];
  onChange: (type: string, val: string) => void;
  value: {
    category: string;
    industry: string;
  };
};
export function BlogFilters(props: Props) {
  const {
    categories = [],
    industries = [],
    onChange,
    value
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const isLg = useMediaQuery(up("lg"));
  const filters: Filter[] = [{
    title: "Category",
    options: [DEFAULT_CATEGORY, ...mapOptions(categories)],
    type: isLg ? "radio" : "dropdown",
    value: value.category
  }, {
    title: "Industry",
    options: [DEFAULT_INDUSTRY, ...mapOptions(industries)],
    type: "dropdown",
    value: value.industry
  }];
  return <_StyledDiv $_css={[{
    "borderTopWidth": "1px",
    "borderBottomWidth": "1px"
  }, {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }, themeStyle.border]}>
      <Wrap mode="light">
        <_StyledDiv2>
          <span>Show</span>
          <FilterBar filters={filters} onChange={onChange} />
        </_StyledDiv2>
      </Wrap>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1p8hnih-0"
})`${p => p.$_css}`;
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "blog-filters___StyledDiv2",
  componentId: "sc-y86dt3-0"
})({
  "position": "relative",
  "zIndex": "10",
  "display": "flex",
  "flexWrap": "wrap",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1.6rem",
  "padding": "1.6rem",
  "@media (min-width: 1024px)": {
    "justifyContent": "flex-start",
    "paddingLeft": "8rem",
    "paddingRight": "8rem",
    "paddingTop": "2.4rem",
    "paddingBottom": "2.4rem"
  }
});